module.exports = __webpack_public_path__ + "img/magento-custom-development_medium@2x.59ec5c4d.jpg";